"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckSpan = exports.Container = exports.StyledCheckbox = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledCheckbox = styled_components_1.default.input `
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;
exports.Container = styled_components_1.default.label `
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  color: #8a94a6;

  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  &:hover input ~ span {
    background-color: #ccc;
  }

  & input:checked ~ span:after {
    display: block;
  }

  & span::after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid #0085ff;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;
exports.CheckSpan = styled_components_1.default.span `
  position: absolute;
  top: 0;
  left: 0;
  height: 24px;
  width: 24px;
  background-color: #f1f7fd;
  border: 1px solid #c1c9d0;
  box-shadow: inset 0px 2px 6px rgba(0, 0, 0, 0.1),
    inset 0px 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 7px;

  &::after {
    content: "";
    position: absolute;
    display: none;
  }
`;
//# sourceMappingURL=styled.js.map